import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Redirect legacy `/project-operations/:projectId?tab=…` links to query-param form.
 *
 * @returns {JSX.Element}
 */
const ProjectOperationsLegacyRedirect = () => {
    const { projectId } = useParams();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab') || 'control';
    const section = searchParams.get('section');
    const query = new URLSearchParams({ tab, project: String(projectId) });
    if (section) {
        query.set('section', section);
    }
    return <Navigate to={`/project-operations?${query.toString()}`} replace />;
};

export default ProjectOperationsLegacyRedirect;
